"use client";

import { Truck, Shield, RotateCcw } from "lucide-react";
import { DeliveryService } from "./types";
import { Config } from "@nusrif/types";

// Local type that allows React components for icons
type LocalDeliveryService = Omit<DeliveryService, 'icon'> & {
  icon: any; // Using any to avoid React type conflicts
  highlight?: boolean;
};

interface DefaultServicesProps {
  config: Config;
}

export const DefaultServices = ({ config }: DefaultServicesProps) => {
  const minOrder = config.minimumOrderValueForFreeDelivery;
  const codAvailable = config.cod === 'true';
  const returnDays = config.returnPeriodDays;

  const defaultServices: LocalDeliveryService[] = [
    {
      icon: Truck,
      title: `Free delivery on orders above ₹${minOrder}`,
      subtitle: "",
      value: ""
    },
    // Only include COD if available
    ...(codAvailable
      ? [{
          icon: Shield,
          title: "Cash on Delivery available",
          subtitle: "",
          value: "",
          highlight: true
        }]
      : []),
    {
      icon: RotateCcw,
      title: `${returnDays} days easy return policy`,
      subtitle: "",
      value: ""
    }
  ];
  return (
    <div className="space-y-3">
      {defaultServices.map((service, index) => (
        <div
          key={index}
          className={`flex items-center gap-3 ${service.highlight ? 'text-green-600 font-semibold' : 'text-gray-600'}`}
        >
          <service.icon className="w-5 h-5" />
          <span className="text-sm">{service.title}</span>
        </div>
      ))}
    </div>
  );
};